import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { getNumberWithoutSpaces } from '../../../../../../common/utils/format';

const Controls = ({ prev, next }) => {
  return (
    <div className="navigation-orders">
      {prev ? (
        <div className="navigation-orders__item">
          <Button ghost type="primary" size="large">
            <Link to={`/executorship/order/${prev.id}`}>Предыдущий заказ</Link>
          </Button>
          <span className="capt">
            {getNumberWithoutSpaces(prev.info.offerNumber)}
          </span>
        </div>
      ) : null}
      {next ? (
        <div className="navigation-orders__item">
          <Button ghost type="primary" size="large">
            <Link to={`/executorship/order/${next.id}`}>Следующий заказ</Link>
          </Button>
          <span className="capt">
            {getNumberWithoutSpaces(next.info.offerNumber)}
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default Controls;
